module.exports = require('./helpers/bundle-url').getBundleURL('fJDP7') + "logo.c5857b8b.svg";